/** UK/US split helpers. Every headline number in the cockpit carries both. */
export type Market = 'uk' | 'us';
export interface Split { uk: number; us: number }

export const ZERO: Split = { uk: 0, us: 0 };
export const sum = (s: Split | null | undefined): number => (s ? Number(s.uk ?? 0) + Number(s.us ?? 0) : 0);
export const n = (v: unknown): number => (typeof v === 'number' ? v : Number(v ?? 0) || 0);
export const split = (s: Partial<Split> | null | undefined): Split => ({ uk: n(s?.uk), us: n(s?.us) });
export const marketLabel = (m: string | null | undefined): string => (m === 'us' ? 'US' : 'UK');

/** "UK 81 · US 4" */
export const splitText = (s: Split | null | undefined, fmt: (v: number) => string = v => v.toLocaleString('en-GB')): string =>
  `UK ${fmt(n(s?.uk))} · US ${fmt(n(s?.us))}`;
